/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBoolean = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M16 2v6h6v14H8v-6H2V2zm4 8h-4v6h-6v4h10zm-6-6H4v10h4V8h6zm0 6h-4v4h4z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgBoolean as Boolean };
